/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { logAdminControllerSearchV1 } from '../fn/log-admin/log-admin-controller-search-v-1';
import { LogAdminControllerSearchV1$Params } from '../fn/log-admin/log-admin-controller-search-v-1';
import { LogSearchResponseDto } from '../models/log-search-response-dto';

@Injectable({ providedIn: 'root' })
export class LogAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `logAdminControllerSearchV1()` */
  static readonly LogAdminControllerSearchV1Path = '/api/v1/logs/admin';

  /**
   * 로그 목록 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `logAdminControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  logAdminControllerSearchV1$Response(params: LogAdminControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LogSearchResponseDto>> {
    const obs = logAdminControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 로그 목록 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `logAdminControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  logAdminControllerSearchV1(params: LogAdminControllerSearchV1$Params, context?: HttpContext): Observable<LogSearchResponseDto> {
    const resp = this.logAdminControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<LogSearchResponseDto>): LogSearchResponseDto => r.body)
    );
  }

}
